import { Component, OnInit, ViewEncapsulation, Injector } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ControlBase } from '../../base/control-base/control-base.component';

@Component({
    selector: 'cookie-consent-control',
    templateUrl: './cookie-consent.control.html',
    styleUrl: 'cookie-consent.control.scss',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CookieConsentControl extends ControlBase implements OnInit {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
        this.seen = true;
    }

    public seen: boolean;

    public cookieName: string = 'cookieConsentAccepted';

    public ngOnInit(): void {
        this.seen = this.ioc.cookieService.check(this.cookieName);
    }

    public dismiss(evt?: MouseEvent): void {
        if (evt) {
            evt.preventDefault();
        }
        const now: Date = new Date();
        const expiration: Date = new Date(now.getTime() + 50000 * 86400000);

        this.ioc.cookieService.set(this.cookieName, 'true', expiration);
        this.seen = true;
    }
}
